import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";

var without = require("lodash/without");

var each = require("lodash/each");

export var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.listeners = [];
  }

  _createClass(EventEmitter, [{
    key: "addListener",
    value: function addListener(fn) {
      var _this = this;

      this.listeners.push(fn);
      return function () {
        _this.listeners = without(_this.listeners, fn);
      };
    }
  }, {
    key: "trigger",
    value: function trigger() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      each(this.listeners, function (fn) {
        fn.apply(null, args);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.listeners = [];
    }
  }]);

  return EventEmitter;
}();